module.exports = __webpack_public_path__ + "static/media/Desktop_WhatIsCulture_7.3d01a405.png";